import { format } from "date-fns";
import { Information } from "features/History/HistoryDetail/fetchHistoryDetail";
import { FC } from "react";
import { Flex, Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

type HeaderProps = {
  information: Information;
};

export const DetailsHeader: FC<HeaderProps> = ({ information }) => {
  const theme = useTheme();
  return (
    <Flex gap="8px" alignItems="center">
      <Text style={{ fontSize: "30px" }} fontWeight="bold">
        {information.type.label ?? "-"}
      </Text>
      <Text style={{ fontSize: "24px" }} color={theme.colorTextSecondary}>
        / {format(information.createdAt, "dd.MM.yyyy")}
      </Text>
      {information.stretchName && (
        <Text style={{ fontSize: "24px" }} color={theme.colorTextSecondary}>
          / {information.stretchName}
        </Text>
      )}
    </Flex>
  );
};
